import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import "./BDNSummary.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import { getBdnSummaryData } from "../../../../../../services/ChildReportService";
import { BDN_SUMMARY_DATA } from "../../../../../../constants/ReportedDataMenus_constants";

import { emitToasterMsg } from "../../../../../../services/toasterUtility";
import axiosHttp from "../../../../../../services/interceptor";
import Loader from "../../../../../../common/Loader/Loader";
import {getFuelRegistry} from "../../../../../../services/CIIData-service";

const BDNSummary = () => {
	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);

	const [BDNData, setBDNData] = useState([]);
	const [exportLoading, setExportLoading] = useState(false);
	const [annualExportLoading, setAnnualExportLoading] = useState(false);
	const [correctionExportLoading, setCorrectionExportLoading] =
		useState(false);
	const [tankOilExportLoading, setTankOilExportLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [loading, setLoading] = useState(true);
	const [fuelNameMap, setFuelNameMap] = useState({});
	const [fuelBdnIdMap, setFuelBdnIdMap] = useState({});

   // Fetch fuel registry data for the vessel and create a mapping of fuelType to fuelName and BDN|ID
	useEffect(() => {
		const vesselId = reportDetails?.VesselMstId;
		if (vesselId) {
			getFuelRegistry(vesselId).then((list) => {
				const nameMap = {};
				const bdnIdMap = {};
				list.forEach((fuel) => {
					nameMap[fuel.fuelType] = fuel.fuelName || fuel.fuelType;
					// Find the BDN|ID metadata
					const bdnMeta = fuel.metadata?.find((m) => m.metaKey === "BDN|ID");
					if (bdnMeta && bdnMeta.metaValue) {
						bdnIdMap[fuel.fuelType] = bdnMeta.metaValue;
					}
				});
				setFuelNameMap(nameMap);
				setFuelBdnIdMap(bdnIdMap);
			});
		}
	}, [reportDetails]);

	const fetchBDNSummary = async () => {
		setLoading(true);
		try {
			setIsLoading(true);
			const BDNData = await getBdnSummaryData(reportDetails?.ReportMstId);
			setLoading(false);
			setBDNData(BDNData.data.data);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.error(
				"error",
				"BDN Summary",
				error?.response?.errorMessage
			);
		}
	};

	useEffect(() => {
		fetchBDNSummary();
	}, []);

	const handleBDNExportTable = () => {
		setExportLoading(true);
		const reportMstId = reportDetails?.ReportMstId;
		axiosHttp
			.get(`api/VoyageBdn/GetBdnTypeExcel`, {
				params: { reportMstId },
				responseType: "blob",
			})
			.then((response) => {
				if (response.status === 200) {
					const contentType = response?.headers["content-type"];
					if (
						contentType ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						const blob = new Blob([response?.data], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", "BDN-Export.xlsx");
						document.body.appendChild(link);
						link.click();
						emitToasterMsg(
							"success",
							"BDN.xlsx",
							"Exported successfully"
						);
						document.body.removeChild(link);
					} else {
						emitToasterMsg(
							"error",
							"Export All BDN",
							"Unexpected content type received"
						);
					}
				}
			})
			.catch((error) => {
				console.error(
					"error",
					"Error Exporting BDN:",
					error?.response?.data?.errorMessage
				);
			})
			.finally(() => {
				setExportLoading(false);
			});
	};

	const handleBDNSummaryExportTable = () => {
		setTankOilExportLoading(true);
		const reportMstId = reportDetails?.ReportMstId;
		axiosHttp
			.get(`api/VoyageBdn/GetRobResponseExcel`, {
				params: { reportMstId },
				responseType: "blob",
			})
			.then((response) => {
				if (response.status === 200) {
					const contentType = response?.headers["content-type"];
					if (
						contentType ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						const blob = new Blob([response?.data], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"Tank-Oil-Remaining-Export.xlsx"
						);
						document.body.appendChild(link);
						link.click();
						emitToasterMsg(
							"success",
							"Tank-Oil-Remaining.xlsx",
							"Exported successfully"
						);
						document.body.removeChild(link);
					} else {
						emitToasterMsg(
							"error",
							"Export All Tank-Oil-Remaining",
							"Unexpected content type received"
						);
					}
				}
			})
			.catch((error) => {
				console.error(
					"error",
					"Error Exporting Tank-Oil-Remaining:",
					error?.response?.data?.errorMessage
				);
			})
			.finally(() => {
				setTankOilExportLoading(false);
			});
	};

	const handleOtherCorrectionExportTable = () => {
		setCorrectionExportLoading(true);
		const reportMstId = reportDetails?.ReportMstId;
		axiosHttp
			.get(`api/VoyageBdn/GetCorTypeExcel`, {
				params: { reportMstId },
				responseType: "blob",
			})
			.then((response) => {
				if (response.status === 200) {
					const contentType = response?.headers["content-type"];
					if (
						contentType ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						const blob = new Blob([response?.data], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"Other-Correction-Export.xlsx"
						);
						document.body.appendChild(link);
						link.click();
						emitToasterMsg(
							"success",
							"Other-Correction.xlsx",
							"Exported successfully"
						);
						document.body.removeChild(link);
					} else {
						emitToasterMsg(
							"error",
							"Export All Other-Correction",
							"Unexpected content type received"
						);
					}
				}
			})
			.catch((error) => {
				console.error(
					"error",
					"Error Exporting Other-Correction:",
					error?.response?.data?.errorMessage
				);
			})
			.finally(() => {
				setCorrectionExportLoading(false);
			});
	};

	const handleAnnualFuelConsumptionExportTable = () => {
		const reportMstId = reportDetails?.ReportMstId;
		axiosHttp
			.get(
				`api/VoyageBdn/GetAnnualFuelConsumptionExcel`,

				{
					params: { reportMstId },
					responseType: "blob",
				}
			)
			.then((response) => {
				if (response.status === 200) {
					const contentType = response?.headers["content-type"];
					if (
						contentType ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						const blob = new Blob([response?.data], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"Annual-Fuel-Consumption-Export.xlsx"
						);
						document.body.appendChild(link);
						link.click();
						emitToasterMsg(
							"success",
							"Annual-Fuel-Consumption.xlsx",
							"Exported successfully"
						);
						document.body.removeChild(link);
					} else {
						emitToasterMsg(
							"error",
							"Export All Annual-Fuel-Consumption",
							"Unexpected content type received"
						);
					}
				}
			})
			.catch((error) => {
				console.error(
					"error",
					"Error Exporting Annual-Fuel-Consumption:",
					error?.response?.data?.errorMessage
				);
			})
			.finally(() => {
				setAnnualExportLoading(false);
			});
	};

	const generateColumns = (data, nameMap, bdnIdMap, additionalColumn = null) => {
		const baseColumns = data.map((item) => {
			const displayName = nameMap[item.headerName] || item.headerName;
			const bdnId = bdnIdMap[item.headerName]; // item.headerName is the fuelType

			// Build header with tooltip if BDN ID exists
			const headerContent = bdnId ? <span title={`BDN ID: ${bdnId}`}>{displayName}</span> : displayName;

			return {
				accessorKey: item.headerName,
				header: headerContent, // now a JSX element or string
				Cell: ({ row }) => {
					const key = row.original.key;
					const value = item.values.find((v) => v.key === key)?.value || "";
					return value;
				},
			};
		});
		// Add additional column if provided
		if (additionalColumn) {
			baseColumns.unshift({
				accessorKey: additionalColumn.accessorKey,
				header: additionalColumn.header,
				Cell: ({ row }) => additionalColumn.value || "",
			});
		}

		return baseColumns;
	};
	const transformData = (data, additionalColumn = null) => {
		const keys = data[0]?.values.map((item) => item.key) || [];

		return keys.map((key) => {
			const row = { key };
			data.forEach((item) => {
				row[item.headerName] =
					item.values.find((v) => v.key === key)?.value || "";
			});

			// Add value for the additional column if provided
			if (additionalColumn) {
				row[additionalColumn.accessorKey] =
					additionalColumn.value || "";
			}

			return row;
		});
	};

	const tableConfigs = [
		{
			data: BDNData.bdnSummeryData,
			header: BDN_SUMMARY_DATA.BDN,
			subHeader: BDN_SUMMARY_DATA.FUEL_TYPE,
			handleExport: handleBDNExportTable,
		},
		{
			data: BDNData.robSummeryData,
			header: BDN_SUMMARY_DATA.REMAINING_OIL,
			subHeader: BDN_SUMMARY_DATA.FUEL_TYPE,
			handleExport: handleBDNSummaryExportTable,
		},
		{
			data: BDNData.corSummeryData,
			header: BDN_SUMMARY_DATA.OTHER_CORRECTION,
			subHeader: BDN_SUMMARY_DATA.FUEL_TYPE,
			handleExport: handleOtherCorrectionExportTable,
		},
		{
			data: BDNData.annualFuelData,
			header: BDN_SUMMARY_DATA.ANNUAL_FUEL_CONSUMPTION,
			subHeader: BDN_SUMMARY_DATA.FUEL_TYPE,
			handleExport: handleAnnualFuelConsumptionExportTable,
		},
	];

	return (
		<>
			{loading ? (
				<div className="loader">
					<Loader />
				</div>
			) : (
				<div className="Bdn-summary-table mb-2 mt-3">
					{tableConfigs.map(
						({ data, header, subHeader, handleExport }, index) => {
							if (!data || data.length === 0) return null;

							let additionalColumn = null;

							// Add an additional column for BDNData.annualFuelData
							if (
								header ===
								BDN_SUMMARY_DATA.ANNUAL_FUEL_CONSUMPTION
							) {
								additionalColumn = {
									accessorKey: "ggg",
									value: "Annual Fuel Consumption",
								};
							}

							const columns = generateColumns(
								data,fuelNameMap,fuelBdnIdMap,
								additionalColumn
							);
							const tableData = transformData(
								data,
								additionalColumn
							);

							const tableClassName =
								header ===
								BDN_SUMMARY_DATA.ANNUAL_FUEL_CONSUMPTION
									? "annual-fuel-table"
									: "default-table";

							return (
								<div key={index} className={tableClassName}>
									<CustomTable
										columnsData={columns}
										renderTableData={tableData}
										customProps={{
											header,
											subHeader,
											handleExportTable: handleExport,
											showExportButton: true,
											enableSort: false,
											isLoading,
										}}
									/>
									<br />
								</div>
							);
						}
					)}
				</div>
			)}
		</>
	);
};
export default BDNSummary;
